import React, { FC, ReactNode } from 'react';
import { Box, Container, Grid, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';

interface HeaderProps extends StyleProps {
  title: string;
  description: ReactNode;
  hasTextBlock?: boolean;
  listItems?: Array<{ title: string; text: string }>;
}

type StyleProps = {
  image: string;
};

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      backgroundImage: ({ image }: Partial<StyleProps>) => `url(${image})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      padding: theme.spacing(20, 0, 16),
      marginTop: 0,
      minHeight: 400,
      maxHeight: 800,
      backgroundPosition: 'center',
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(20, 0, 16),
        marginTop: theme.spacing(13.5),
      },
    },
    title: {
      color: theme.palette.common.white,
      fontWeight: 700,
    },
    description: {
      color: theme.palette.common.white,
      maxWidth: 1000,
    },
    number: {
      color: theme.palette.common.white,
      fontWeight: 700,
    },
    text: {
      color: theme.palette.common.white,
      maxWidth: 148,
    },
  });
});

const Header: FC<HeaderProps> = ({ title, description, hasTextBlock = false, image, listItems }) => {
  const classes = useStyles({ image });
  const isMediumUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  return (
    <Box className={classes.root}>
      <Container fixed>
        <Typography variant={isMediumUp ? 'h1' : 'h2'} className={classes.title} data-aos="fade-right" data-aos-duration="700">
          {title}
        </Typography>
        <Box mt={5} mb={8}>
          <Typography
            variant="h5"
            className={classes.description}
            data-aos="fade-right"
            data-aos-duration="600"
            data-aos-delay="200"
          >
            {description}
          </Typography>
        </Box>
        {hasTextBlock && (
          <Grid container direction="row" justify="space-between" spacing={4}>
            {listItems.map(({ title, text }, index) => (
              <Grid xs={6} sm={4} md="auto" item key={index} data-aos="fade-up" data-aos-delay="300">
                <Grid container direction="column">
                  <Grid item>
                    <Typography variant={isMediumUp ? 'h3' : 'h5'} className={classes.number}>
                      {title}
                    </Typography>
                  </Grid>
                  <Box mb={1} />
                  <Grid item>
                    <Typography className={classes.text}>{text}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
      <Box id={'background'} />
    </Box>
  );
};

export default Header;
